<ids-form-field
  *ngIf="type === 'password'"
  [label]="label"
  [errorMessage]="errorMessage"
>
  <input
    idsInput
    updateFirstOnBlur
    [type]="showPassword ? 'text' : 'password'"
    [formControl]="control"
    (input)="onChangeCheck($event)"
  />

  <button
    idsIconButton
    idsSuffix
    [title]="this.showPassword ? 'show password' : 'hide password'"
    (click)="this.showPassword = !this.showPassword"
    class="button-icon"
    type="button"
  >
    <ids-icon variant="primary">
      {{ this.showPassword ? "visivel_outline" : "olho_inativo_outline" }}
    </ids-icon>
  </button>
</ids-form-field>

<ids-form-field
  *ngIf="type !== 'password'"
  [label]="label"
  [errorMessage]="errorMessage"
  [description]="description"
>
  <input
    idsInput
    updateFirstOnBlur
    [type]="type"
    [formControl]="control"
    (input)="onChangeCheck($event)"
    (blur)="fieldBlur.emit($event)"
  />
</ids-form-field>
